import { useState } from "react";
import { useSearchParams, Link, useNavigate } from "react-router-dom";
import api from "../lib/api";
import { toast } from "sonner";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token");
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (password.length < 6) return toast.error("Password must be at least 6 characters");
    if (password !== confirm) return toast.error("Passwords don't match");
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success("Password reset! Sign in with your new password.");
      navigate("/login");
    } catch (err) {
      const d = err.response?.data?.detail;
      toast.error(typeof d === "string" ? d : "Reset failed");
    } finally {
      setLoading(false);
    }
  };

  if (!token) {
    return (
      <div className="min-h-screen bg-[#050505] flex items-center justify-center px-4">
        <div className="text-[#aaa]">Invalid reset link. <Link to="/login" className="text-[#E50914]">Sign in</Link></div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[#050505] flex items-center justify-center px-4" data-testid="reset-password-page">
      <div className="w-full max-w-md bg-[#0a0a0a] border border-white/10 rounded-2xl p-10">
        <h1 className="text-3xl font-black mb-2" style={{ fontFamily: "Outfit" }}>New password</h1>
        <p className="text-sm text-[#aaa] mb-6">Choose a strong password you haven't used before.</p>
        <form onSubmit={submit} className="space-y-4">
          <input type="password" required minLength={6} value={password} onChange={(e) => setPassword(e.target.value)} className="w-full px-4 py-3 rounded-md bg-[#1a1a1a] border border-white/10 text-white focus:border-[#E50914] focus:outline-none" placeholder="New password (min 6)" data-testid="new-password-input" />
          <input type="password" required value={confirm} onChange={(e) => setConfirm(e.target.value)} className="w-full px-4 py-3 rounded-md bg-[#1a1a1a] border border-white/10 text-white focus:border-[#E50914] focus:outline-none" placeholder="Confirm password" data-testid="confirm-password-input" />
          <button type="submit" disabled={loading} className="w-full btn-primary justify-center" data-testid="reset-submit-btn">
            {loading ? "Saving..." : "Reset password"}
          </button>
        </form>
      </div>
    </div>
  );
}
